<template>
  <div class="animated fadeIn">
    <basic-heading title="Prep Workflow" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['list sample type', 'list prep process']">
      <template #gated-content>
        <WorkflowPrepServerTable />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import WorkflowPrepServerTable from '@/components/lab/workflows/prep/WorkflowPrepServerTable'

export default {
  name: 'WorkflowPrepIndex',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    WorkflowPrepServerTable
  },
  computed: {
    button_config () {
      return {
        buttons: [
        ]
      }
    }
  }
}
</script>
